export const technicalItems = [
        {
            date: '2026-2027',
            title:'Technical and Educational Activities Council Representative',
            text:'IEEE Communications Society (ComSoc) Conference Council'
        },
        {
            date: '2026-Present',
            title:'Chair',
            text:'IEEE Communications Society (ComSoc) Social Networks Technical Committee'
        },


        {
            date: '2023-2025',
            title:'Vice Chair',
            text:'IEEE Communications Society (ComSoc) Social Networks Technical Committee'
        },
        {
            date: '2021-2023',
            title:'Secretary',
            text:'IEEE ComSoc Social Networks Technical Committee'
        },
        {
            date: '2019-2020',
            title:'Chair',
            text:'IEEE ComSoc Communication Systems Integration and Modelling Technical Committee'
        },
        {
            date: '2017-2018',
            title:'Vice-Chair',
            text:'IEEE ComSoc Communication Systems Integration and Modelling Technical Committee'
        },
        {
            date: '2015-2017',
            title:'Secretary',
            text:'IEEE ComSoc Communication Systems Integration and Modelling Technical Committee'
        },


    ];